import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController } from 'ionic-angular';

import { User, Master } from '@providers/advance_providers'

@Component({
  selector: 'page-detail-adv',
  templateUrl: 'page.html'
})
export class DetailAdvPage {

  params:any={};
  req_item:any;
  id:0;
  detail:any;
  list:any=[];

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    public userApi:User,
    public masterApi:Master
  ) {
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    this.req_item =  this.navParams.get('item');
    this.id = this.navParams.get('id');
    loading.dismiss();
  }
  
  localFormating(v){
    v = parseFloat(v);
    v = v.toLocaleString(['ban', 'id']);
    if(v=='NaN'){
      v='-';
    }
    return v;
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top' 
    });
  }

  // getDetail(){
  //   let params = {id:this.id};
  //   this.masterApi.getDetail(params).subscribe((resp:any) => {
  //     if(resp == ''){
  //       this.presentToast("Advance detail empty !");
  //     }
  //     this.list = resp.data
  //     console.log(this.list);
  //   })
  // }

}



// WEBPACK FOOTER //
// ./src/pages/advance_mobile/detail_adv/page.ts